<template>
  <div class="special_home_container" ref="special_detail">
    <div class="special_info" v-if="!!detail">
      <!-- 默认大图 -->
      <div class="special_detault_img" v-if="detail.indexBackMode == 0">
        <div class="img">
          <img :src="detail.bigResouceUrl" :onerror="imgLoadError(detail)" alt="" />
        </div>
      </div>
      <!-- 背景海报、多张 -->
      <div class="special_poster_imgs" v-else-if="detail.indexBackMode == 1 && detail.backPosterPicArray.length>0" :style="{ height: posterHeight }">
        <div class="swipe_box">
          <van-swipe :show-indicators="true" :loop="true" :autoplay="3000">
            <van-swipe-item v-for="(item, index) in detail.backPosterPicArray" :key="index">
              <div class="img" :style="{backgroundImage:'url(' +(item.picUrl == ''? require('@/assets/images/user_default.png'): item.picUrl) +')',}"></div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <!-- 背景方图、多张 -->
      <div class="special_block_imgs" v-else-if="detail.indexBackMode == 2 && detail.backBlockPicArray.length>0">
        <div class="swipe_box">
          <van-swipe :show-indicators="true" :loop="true" :autoplay="3000">
            <van-swipe-item v-for="(item, index) in detail.backBlockPicArray" :key="index">
              <div class="img" :style="{backgroundImage:'url(' +(item.picUrl == ''? require('@/assets/images/user_default.png'): item.picUrl) +')',}"></div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <!-- 普通大图、多张 -->
      <div class="special_normal_imgs" v-else-if="detail.indexBackMode == 3 && detail.backNormalPicArray.length>0">
        <div class="swipe_box">
          <van-swipe :show-indicators="true" :loop="true" :autoplay="3000">
            <van-swipe-item v-for="(item, index) in detail.backNormalPicArray" :key="index">
              <div class="img" :style="{backgroundImage:'url(' +(item.picUrl == ''? require('@/assets/images/user_default.png'): item.picUrl) +')',}"></div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <!-- 默认大图 -->
      <div class="special_detault_img" v-else>
        <div class="img">
          <img :src="detail.bigResouceUrl" :onerror="imgLoadError(detail)" alt="" />
        </div>
      </div>
      <div class="special_category" v-if="specialCategoryList.length > 0">
        <van-tabs class="special_category_tabs" @click="onTabClick" v-model="selectedIndex" swipe-threshold="2" :line-width="lineWidth" sticky :offset-top=offsetTop>
          <van-tab v-for="item in specialCategoryList" :title="item.name" :key="item.id">
            <div class="cate_content_list">
              <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="special_news_list" :disabled="refDisabled">
                <van-list v-model="loading" :offset="10" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoadMore">
                  <van-cell v-for="item in specialNewsList" :key="item.id">
                    <content-data :dataItem="item"></content-data>
                  </van-cell>
                </van-list>
              </van-pull-refresh>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import specialApi from "@/api/apis/special.js";
import ContentData from "./SpecialContentData";
export default {
  name: "specialTemplate",
  props: {
    contentId: {
      type: Number,
      default: null,
    },
    detail: {
      type: Object,
      default: null,
    }
  },
  components: {
    ContentData,
  },
  data() {
    return {
      posterHeight: 'auto',
      offsetTop: 0,
      refDisabled: false, //下拉刷新是否禁用
      scrollTop: 0,
      specialCategoryList: [], //专题内容分类
      selectedIndex: 0,
      lineWidth: 0, //Tab标签底部条宽度
      refreshing: false,
      loading: false,
      finished: false,
      params: {
        currentPage: 0,
        pageSize: 20,
        contentClassifyId: null,
      },
      specialNewsList: [], //专题新闻列表
      specialNewsTotal: 0, //专题新闻总数
      specialNewsPageCount: 0, //专题新闻分页数
      loadFirstPage: true, //是否加载第一页,用来解决vant上拉加载本身的缺陷问题
    };
  },
  watch: {
    scrollTop(val) {
      if (val == 0) {
        this.refDisabled = false
      } else {
        this.refDisabled = true
      }
    }
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 切换分类 */
    onTabClick(index) {
      var _this = this;
      _this.selectedIndex = index;
      _this.params.contentClassifyId = _this.specialCategoryList[index].id;
      _this.lineWidth = _this.specialCategoryList[index].name.length * 14;
      _this.params.currentPage = 0;
      _this.specialNewsList = [];
      _this.specialNewsTotal = 0;
      _this.specialNewsPageCount = 0;
      _this.loadFirstPage = true;
      if (_this.finished) {
        _this.refreshing = false;
      } else {
        _this.refreshing = true;
      }
      _this.loading = false;
      _this.finished = false;
      _this.getSpecialContentsByClassifyId();
    },
    /* 获取专题稿件分类 */
    getSpecialById() {
      var _this = this;
      var params = { contentId: _this.contentId };

      specialApi
        .getSpecialById(params)
        .then((res) => {
          this.refreshing = false;
          if (res.suc == 1) {
            _this.specialCategoryList = res.data.list;
            if (_this.specialCategoryList.length > 0) {
              _this.params.contentClassifyId = _this.specialCategoryList[0].id;
              _this.lineWidth = _this.specialCategoryList[0].name.length * 14;
              _this.getSpecialContentsByClassifyId();
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 根据专题内容分类Id获取专题内容列表 */
    getSpecialContentsByClassifyId() {
      var _this = this;
      specialApi
        .getSpecialContentsByClassifyId(_this.params)
        .then((res) => {
          _this.refreshing = false;
          _this.loading = false;
          if (res.suc == 1) {
            if (_this.params.currentPage == 0) {
              _this.specialNewsList = res.data.list;
            } else {
              _this.specialNewsList = _this.specialNewsList.concat(
                res.data.list
              );
            }
            _this.specialNewsTotal = res.data.total;
            _this.specialNewsPageCount = Math.ceil(
              res.data.total / _this.params.pageSize
            );
            if (_this.params.currentPage >= _this.specialNewsPageCount - 1) {
              _this.finished = true;
            }
            _this.loadFirstPage = false;
          } else {
            /* _this.$toast({
              message: res.message || res.text,
              position: "center",
            }); */
            _this.finished = true;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 下拉刷新 */
    onRefresh() {
      this.params.currentPage = 0;
      // this.specialNewsList = [];
      this.specialNewsTotal = 0;
      this.specialNewsPageCount = 0;
      this.loadFirstPage = true;
      if (this.finished) {
        this.refreshing = false;
      } else {
        this.refreshing = true;
      }
      this.loading = false;
      this.finished = false;
      this.getSpecialContentsByClassifyId(); //根据专题内容分类Id获取专题内容列表
    },
    /* 上拉加载 */
    onLoadMore() {
      if (!this.loadFirstPage) {
        this.params.currentPage++;
        if (this.params.currentPage < this.specialNewsPageCount) {
          this.getSpecialContentsByClassifyId(); //根据专题内容分类Id获取专题内容列表
        }
      }
    },
  },
  created() {
    if (!!this.contentId) {
      this.getSpecialById(); //获取专题稿件分类
    }
  },
  updated() {
    var ele1 = document.getElementsByClassName("top_header");
    let h1 = 0;
    if (ele1.length > 0) {
      h1 = ele1[0].clientHeight;
    }
    this.posterHeight = window.innerHeight - h1 + "px";
  },
  mounted() {
    let _this = this;
    // 设置粘性布局高度
    _this.offsetTop = document.getElementsByClassName('top_header')[0].offsetHeight;
    window.onresize = function () {
      _this.offsetTop = document.getElementsByClassName('top_header')[0].offsetHeight;
    }
    // 下拉刷新判断
    let box = this.$refs.special_detail;
    box.addEventListener('scroll', () => {
      this.scrollTop = box.scrollTop;
    });
  },
};
</script>
<style scoped lang="scss">
.special_home_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  .special_info {
    background-color: #fff;
    /* 默认大图 */
    .special_detault_img {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      background-image: url(~@/assets/images/default_pic_16_9.png);
      overflow: hidden;
      .img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        img {
          object-fit: cover;
          min-width: 100%;
          min-height: 100%;
        }
      }
    }
    /* 海报 */
    .special_poster_imgs {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      .swipe_box {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        .van-swipe {
          width: 100%;
          height: 100%;
          .van-swipe-item {
            .img {
              width: 100%;
              height: 100%;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }
        }
      }
    }
    /* 方图 */
    .special_block_imgs {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 100%;
      overflow: hidden;
      .swipe_box {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        .van-swipe {
          width: 100%;
          height: 100%;
          .van-swipe-item {
            .img {
              width: 100%;
              height: 100%;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }
        }
      }
    }
    /* 普通大图 */
    .special_normal_imgs {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
      overflow: hidden;
      .swipe_box {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        .van-swipe {
          width: 100%;
          height: 100%;
          .van-swipe-item {
            .img {
              width: 100%;
              height: 100%;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }
        }
      }
    }
    .special_category {
      /deep/.van-sticky{
        box-shadow: 0 5px 5px #ddd;
      }
      /deep/.van-tab,
      /deep/.van-tabs__wrap--scrollable .van-tab{
        flex: none;
      }
    }
  }
  .cate_content_list {
    position: relative;
    width: 100%;
    height: auto;
    margin-top: 15px;
    .special_news_list {
      padding: 0 15px;
    }
    .van-cell{
      padding: 0;
    }
  }
}
</style>